// extracted by mini-css-extract-plugin
export var addButton = "_ez-0";
export var border = "_ez-8";
export var check = "_ez-h";
export var danger = "_ez-6";
export var dropdownContainer = "_ez-1";
export var editModalBody = "_ez-j";
export var footerContainer = "_ez-i";
export var fullWidth = "_ez-a";
export var hide = "_ez-9";
export var icon = "_ez-3";
export var input = "_ez-7";
export var inputFlex = "_ez-b";
export var inputWrapper = "_ez-c";
export var manualFocus = "_ez-5";
export var optionButton = "_ez-4";
export var pillWrapper = "_ez-e";
export var pointer = "_ez-2";
export var showOverflow = "_ez-f";
export var tagsFlex = "_ez-d";
export var xButton = "_ez-g";